<template>
  <div>
  <navigation-tabs>
    <router-link
      v-for="(v, i) in menuList"
      :key="i"
      :to="{ name: v.pathName, params: { id: $route.params.id } }"
    >
      {{ $t(v.name) }}
    </router-link>
  </navigation-tabs>

    <v-dialog v-model="unsavedChangesDialog" width="450">
      <v-card>
        <v-card-title>
          {{$t('unsaved_changes_dialog_title')}}
        </v-card-title>

        <v-card-text class="pt-3">
          <span v-html="$t('unsaved_changes_dialog_description')"></span>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            color="primary"
            small
            dense
            @click="unsavedChangesDialog = false"
          >
            {{$t('cancel')}}
          </v-btn>

          <v-btn
            text
            color="red"
            small
            dense
            @click="continueNavigation()"
          >
            {{$t('continue_without_saving')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

import { mapGetters, mapMutations } from 'vuex'
import NavigationTabs from '@/components/utils/NavigationTabs'

export default {
  name: 'ProductDetailsNavigation',
  props: ['active'],
  components: {
    NavigationTabs
  },
  data: () => ({
    unsavedChangesDialog: false,
    goingTo: null,
    menuList: [
      {
        name: 'product_information',
        pathName: 'products.info'
      },
      {
        name: 'scan_destination',
        pathName: 'products.redirection'
      },
      {
        name: 'digital_link',
        pathName: 'products.gs1'
      },
      {
        name: 'qr_styling',
        pathName: 'products.qr'
      }
    ]
  }),
  computed: {
    ...mapGetters(['hasUnsavedChanges'])
  },
  mounted () {
    window.addEventListener('unsaved-nav-attempt', this.onUnsavedNavAttempt)
  },
  beforeDestroy () {
    window.removeEventListener('unsaved-nav-attempt', this.onUnsavedNavAttempt)
  },
  methods: {
    ...mapMutations({
      setUnsavedChangesStatus: 'SET_UNSAVED_CHANGES_STATUS'
    }),
    onUnsavedNavAttempt (e) {
      const { to } = e.detail || {}
      if (!to || !to.name) return
      this.goingTo = to.name
      this.unsavedChangesDialog = true
    },
    continueNavigation (tab = this.goingTo) {
      if (!tab) return
      this.unsavedChangesDialog = false
      this.setUnsavedChangesStatus(false)
      window.dispatchEvent(new CustomEvent('discard-unsaved-changes'))
      const target = { name: tab, params: { id: this.$route.params.id } }
      this.goingTo = null
      this.$router.push(target)
    }
  }
}
</script>

<style lang="sass" scoped>

@import "@/variables.sass"
.profile-nav-list
  list-style: none
  margin: 0
  padding: 0
  display: flex
  flex-direction: column

</style>
